try {
  // Saas 线上移除 console
  if (!process.env.BRANCH_ENV || process.env.BRANCH_ENV === 'saas') {
    console.log = function () { };
    console.warn = function () { };
    console.error = function () { };
    console.info = function () { };
  }
} catch (ex) {}
